import React from 'react'
import { I18n } from 'react-redux-i18n'
import { info } from '../../storage'
import ReservationCheckInTypeContainer from './ReservationCheckInTypeContainer'
import AirlineCheckInTypeContainer from './AirlineCheckInTypeContainer'
import WalkinCheckInTypeContainer from './WalkinCheckInTypeContainer'
import { withCheckInType } from './CheckInTypeContainer'

const CheckInTypePanelContainer = ({
  pristine,
  selectCheckInType,
  selectReservation,
  activeDialog,
  onClose,
}) => {
  const handleAirlineSelect = (airline) => {
    selectCheckInType({
      checkInType: 'airline',
      airlineCheckInInfo: { airline },
      agentCheckInInfo: undefined,
      walkinCheckInInfo: undefined,
    })
    onClose()
  }

  const handleCashSelect = () => {
    selectCheckInType({
      checkInType: 'walkin',
      airlineCheckInInfo: undefined,
      agentCheckInInfo: undefined,
      walkinCheckInInfo: { type: 'cash' },
    })
    onClose()
  }

  const handleCreditCardSelect = () => {
    selectCheckInType({
      checkInType: 'walkin',
      airlineCheckInInfo: undefined,
      agentCheckInInfo: undefined,
      walkinCheckInInfo: { type: 'creditCard' },
    })
    onClose()
  }

  const handleCardSelect = (card) => {
    selectCheckInType({
      checkInType: 'walkin',
      airlineCheckInInfo: undefined,
      agentCheckInInfo: undefined,
      walkinCheckInInfo: { type: 'card', card },
    })
    onClose()
  }

  const handleOtherSelect = () => {
    selectCheckInType({
      checkInType: 'walkin',
      walkinCheckInInfo: { type: 'others' },
    })
    onClose()
  }

  const handleReservationSelect = (reservation) => {
    selectReservation(reservation, info().serviceId)
    onClose()
  }

  return (
    <CheckInTypePanel
      activeDialog={activeDialog}
      onClose={onClose}
      onAirlineSelect={handleAirlineSelect}
      onReservationSelect={handleReservationSelect}
      onCashSelect={handleCashSelect}
      onCreditCardSelect={handleCreditCardSelect}
      onCardSelect={handleCardSelect}
      onOthersSelect={handleOtherSelect}
    />
  )
}

const CheckInTypePanel = ({
  activeDialog,
  onClose,
  onReservationSelect,
  onAirlineSelect,
  onCashSelect,
  onCreditCardSelect,
  onCardSelect,
  onOthersSelect,
}) => {
  if (!activeDialog) return null

  const dialogTitle = {
    reservation: 'Find Reservation',
    airline: 'Find Airline',
    walkin: I18n.t('checkInScene.checkInType.tabs.walkin'),
  }[activeDialog]

  return (
    <div>
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />

      <div className="fixed inset-0 z-50 flex items-start justify-center pt-16 px-4 pb-20 overflow-y-auto">
        <div
          className="relative bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex items-center justify-between px-6 py-4 border-b">
            <h2 className="text-xl font-semibold text-gray-900">
              {dialogTitle}
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-6">
            {activeDialog === 'reservation' && (
              <ReservationCheckInTypeContainer
                onReservationSelect={onReservationSelect}
              />
            )}
            {activeDialog === 'airline' && (
              <AirlineCheckInTypeContainer onAirlineSelect={onAirlineSelect} />
            )}
            {activeDialog === 'walkin' && (
              <WalkinCheckInTypeContainer
                onCashSelect={onCashSelect}
                onCreditCardSelect={onCreditCardSelect}
                onCardSelect={onCardSelect}
                onOthersSelect={onOthersSelect}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default withCheckInType(CheckInTypePanelContainer)
